// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__7AGDW","row":"Footer_row__s04jT","pageLang":"Footer_pageLang__teG2d"};